module.exports = __webpack_public_path__ + "img/logo_1.037d8090.svg";